import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NotesFilters = ({ 
  filterStatus, 
  setFilterStatus, 
  searchTerm, 
  setSearchTerm, 
  dateRange, 
  setDateRange,
  totalNotes,
  filteredNotes 
}) => {
  const statusOptions = [
    { value: 'all', label: 'Todos los estados', icon: 'FileText' },
    { value: 'pending', label: 'Pendientes', icon: 'Clock' },
    { value: 'in_progress', label: 'En progreso', icon: 'Truck' },
    { value: 'completed', label: 'Completados', icon: 'CheckCircle' }
  ];

  const handleClearFilters = () => {
    setFilterStatus('all');
    setSearchTerm('');
    setDateRange({ start: null, end: null });
  };

  const hasActiveFilters = filterStatus !== 'all' || searchTerm || dateRange.start || dateRange.end;

  return (
    <div className="bg-surface rounded-lg border border-border p-4">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Search */}
        <div className="flex-1 max-w-md">
          <div className="relative">
            <Icon 
              name="Search" 
              size={20} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-muted"
            />
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Buscar por albarán, pedido o cliente..."
              className="pl-10"
            />
          </div>
        </div>

        {/* Status Filter */}
        <div className="flex-1 max-w-xs">
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {statusOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range */}
        <div className="flex space-x-2">
          <Input
            type="date"
            value={dateRange.start ? dateRange.start.toISOString().split('T')[0] : ''}
            onChange={(e) => setDateRange(prev => ({ 
              ...prev, 
              start: e.target.value ? new Date(e.target.value) : null 
            }))}
            placeholder="Fecha inicio"
            className="text-sm"
          />
          <Input
            type="date"
            value={dateRange.end ? dateRange.end.toISOString().split('T')[0] : ''}
            onChange={(e) => setDateRange(prev => ({ 
              ...prev, 
              end: e.target.value ? new Date(e.target.value) : null 
            }))}
            placeholder="Fecha fin"
            className="text-sm"
          />
        </div>

        {/* Clear Filters */}
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleClearFilters}
            iconName="X"
          >
            Limpiar
          </Button>
        )}
      </div>

      {/* Results Summary */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-text-muted">
            Mostrando {filteredNotes} de {totalNotes} albaranes
          </span>
          {hasActiveFilters && (
            <span className="text-primary">
              Filtros aplicados
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotesFilters;